
export const CsvFileDownload = async (response, fileName,fileHeader) => {

    const headers = [
        "Claim_Number",
        "Claim_Seq",
        "Account_No",
        "Procedure_Code",
        "Services_Provided",
        "Member_Id",
        "Member_Name",
        "Modifier",
        "Service_Date",
        "Service_Thru",
        "Svc_Count",
        "Billed_Price",
        "Plan_Price",
        "Discount_Amt",
        "Paid_Amt",
        "Copay_Amt",
        "Not_Covered_Amt",
        "Deductible_Amt",
        "Co_Ins_Amt",
        "COB_Amt",
        "Ex_Code",
        "Ex_Description",
        "Your_Rep",
        "Services_Desc",
        "TableName"
    ];

    const csvText = await response.data.text();

    const csvContent =
        headers.join(",") + "\n" + csvText;

    const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;"
    });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};